const config = {
  development: {

   
    apiUrl: "http://localhost:8084",
    excelApiUrl: "http://13.74.242.1:9001",
    keycloakUrl: "http://localhost:8080/auth",

    realm: "kafein",
    clientId: "micro-reporter-ui",
  },
  test: {
    apiUrl: "http://13.74.242.1",
    excelApiUrl: "http://13.74.242.1:9001",
    keycloakUrl: "https://sso.kafein.com.tr/auth",
    realm: "kafein",
    clientId: "micro-reporter-ui",
  },
  production: {
    apiUrl: "https://microreporter.kafein.com.tr/",
    excelApiUrl: "https://excel.kafein.com.tr",
    keycloakUrl: "https://sso.kafein.com.tr/auth",
    realm: "kafein",
    clientId: "micro-reporter-ui-prod",
  },
  raporproduction: {
    apiUrl: "https://rapor.kafein.com.tr/",
    excelApiUrl: "https://excel.kafein.com.tr",
    keycloakUrl: "https://sso.kafein.com.tr/auth",
    realm: "kafein",
    clientId: "micro-reporter-ui-prod",
  },
  default: {
    apiUrl: "http://13.74.242.1",
    excelApiUrl: "http://13.74.242.1:9001",
    keycloakUrl: "https://sso.kafein.com.tr/auth",
    realm: "kafein",
    clientId: "micro-reporter-ui",
  },
};

export default config;
